import React, { useEffect, useState } from "react";
import "./RecommendationBanner.css";
import RecommendationCard from "./RecommendationCard";
import { API_BASE } from "../config";

const DESKTOP_STEP = 3;
const TABLET_STEP = 2;
const MOBILE_STEP = 1;
const INTERVAL = 7000;
const FADE_MS = 1000;

const RecommendationBanner = () => {
  const [recs, setRecs] = useState([]);
  const [idx, setIdx] = useState(0);
  const [fade, setFade] = useState(false);
  const [currentStep, setCurrentStep] = useState(DESKTOP_STEP);

  // Handle responsive step changes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setCurrentStep(MOBILE_STEP);
      } else if (window.innerWidth <= 768) {
        setCurrentStep(TABLET_STEP);
      } else {
        setCurrentStep(DESKTOP_STEP);
      }
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // fetch on mount
  useEffect(() => {
    fetch(`${API_BASE}/recommendations`)
      .then((r) => (r.ok ? r.json() : []))
      .then((arr) => (Array.isArray(arr) ? arr : []))
      .then(setRecs)
      .catch(console.error);
  }, []);

  // slider timer - reset when step changes
  useEffect(() => {
    if (recs.length === 0) return;

    // Reset index when step changes to avoid out-of-bounds
    setIdx(0);

    const t = setInterval(() => {
      setFade(true);
      setTimeout(() => setIdx((p) => (p + currentStep) % recs.length), FADE_MS);
      setTimeout(() => setFade(false), FADE_MS + 50);
    }, INTERVAL);
    return () => clearInterval(t);
  }, [recs, currentStep]);

  if (recs.length === 0) return null;

  const current = [];
  for (let i = 0; i < currentStep; i++) {
    current.push(recs[(idx + i) % recs.length]);
  }

  return (
    <section className="recommendation-banner">
      <div className={`rec-group ${fade ? "fade" : ""} step-${currentStep}`}>
        {current.map((r) => (
          <RecommendationCard
            key={`${r.rec_id}-${idx}`} // Include idx to force re-render on slide
            quote={r.quote_text}
            name={r.name}
            title={r.title}
            image={r.image_path}
            imageJson={r.image_json}   // <-- pass JSON crops
          />
        ))}
      </div>
    </section>
  );
};

export default RecommendationBanner;
